
import { dayjs } from '@lba-dev/package.local-globals/dayjs';

export const createGoogleCalendar = (time, title, details) =>
  window.open(`http://www.google.com/calendar/event?action=TEMPLATE&text=${title}&dates=${dayjs(time)
    .format('YYYYMMDDTHHmmss')}/${dayjs(time).add(15, 'minute')
    .format('YYYYMMDDTHHmmss')}&details=${encodeURI(details)}&location=Paris`);
